<script setup lang="ts">
import { UiSkeleton } from "@packages/component-library";
import PlaceProductCardSkeleton from "../PlaceMenu/PlaceProductCardSkeleton.vue";
import { IconArrowLeftRegular, IconCloseRegular } from "@packages/icon-library";
import { useRoute } from "vue-router";
import { usePlaceStore } from "@/modules/place-module";
import { computed } from "vue";

const route = useRoute();
const placeStore = usePlaceStore();
const place = computed(() => placeStore.place);
</script>

<template>
  <div class="product-loading">
    <div class="product-loading__content">
      <div class="product-loading__header">
        <RouterLink
          :to="{ name: route.name, query: { place: route.query.place } }"
        >
          <IconArrowLeftRegular />
        </RouterLink>

        <h5>{{ place?.place.title }}</h5>

        <RouterLink :to="{ name: route.name }">
          <IconCloseRegular />
        </RouterLink>
      </div>
      <div class="product-loading__info">
        <UiSkeleton type="card" />
        <UiSkeleton />
        <UiSkeleton />
        <UiSkeleton type="card" />
      </div>
      <div class="product-loading__others">
        <UiSkeleton />

        <div class="product-loading__products">
          <PlaceProductCardSkeleton v-for="item in 4" :key="item" />
        </div>
      </div>
    </div>

    <div class="product-loading__actions">
      <UiSkeleton type="card" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.product-loading {
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr auto;
  padding: 0 0 calc($base-space * 8);
  align-items: start;

  &__content {
    overflow: auto;
    overscroll-behavior: contain;
    height: 100%;
  }

  &__header {
    padding: calc($base-space * 8) calc($base-space * 8) 0;
    display: grid;
    grid-template-columns: 32px 1fr 32px;
    align-items: center;
    gap: calc($base-space * 4);

    > a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
    }

    > h5 {
      @include h5();
      @include max-stroke(1);
      color: var(--color-semantic-content-normal-secondary);
    }
  }

  &__info {
    padding: calc($base-space * 6) calc($base-space * 8);

    > .ui-skeleton {
      &:nth-child(1) {
        width: 100%;
        height: 336px;
      }
      &:nth-child(2) {
        margin: calc($base-space * 6) 0 0;
        max-width: 180px;
        height: 32px;
      }
      &:nth-child(3) {
        margin: calc($base-space * 6) 0 0;
        width: 100%;
        height: 28px;
      }
      &:nth-child(4) {
        margin: calc($base-space * 2) 0 0;
        width: 100%;
        height: 120px;
      }
    }
  }

  &__others {
    border-top: 1px solid var(--color-semantic-border-normal-soft);
    padding: calc($base-space * 6) calc($base-space * 8);

    > .ui-skeleton {
      height: 28px;
      max-width: 200px;
    }
  }

  &__products {
    margin: calc($base-space * 4) 0 0;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: calc($base-space * 4);
    overflow: auto;
    @include hideScroll();

    > .product-card-loading {
      width: 200px;
      flex-shrink: 0;
    }
  }

  &__actions {
    padding: calc($base-space * 4) ($base-space * 8) 0;

    > .ui-skeleton {
      height: 48px;
    }
  }
}
</style>
